'use client'

import { ClientLinkPrimary } from 'fukku/Button/ClientLink/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { REGISTRY_URL } from 'links/registry/constants'
import { sendOnClickCreateAccount } from 'my-purchases/utils/analytics/analyticsEvents'
import { cx } from 'utils/cx'

import styles from './CreateAccount.module.scss'
import text from 'fukku/styles/texts.module.scss'

export function CreateAccount() {
	const { t } = useLabels()

	const clickHandler = () => {
		sendOnClickCreateAccount()
	}

	return (
		<div className={styles.createAccount}>
			<h2 className={cx(styles.title, text.titleL)}>
				{t('myPurchases.login.createAccount.title')}
			</h2>
			<p className={styles.content}>
				{t('myPurchases.login.registerNow.bodycopy')}
			</p>
			<ClientLinkPrimary
				data-testid='myPurchases.login.createAccount.button'
				onClick={clickHandler}
				className={styles.button}
				href={REGISTRY_URL}
			>
				{t('myPurchases.login.createAccount.button')}
			</ClientLinkPrimary>
		</div>
	)
}
